$(document).on("click", "#sidebar-toggle", function (event) {
  if ($("#criteria_toggle").is(":checked")) {
    $("#sidebar-close").click();
  } else {
    $("#sidebar-open").click();
  }
});
